module.exports = __webpack_public_path__ + "static/ebook-collaboration@2x-616972944d67c87dc498b00c142fae6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/ebook-collaboration@2x.png
// module id = 2684
// module chunks = 157636680307020